import * as React from 'react';
import { connect } from 'react-redux';
import { RouterState } from 'react-router-redux';
import { StoreState } from '../../../../../reducers';
import Utils from '../../../../../utils';
import { StyledMenuItem, MenuItemBadge } from '../styles';
import { Dispatch } from 'redux';
import { MenuActionKeys } from '../../../actions';
import { GalleryInfosState } from '../../../../Gallery/reducer';
import { DriveListState } from '../../../../DriveItemList/reducer';
import { MenuItem, MenuItemType } from '../../../../../typings/menu';

export interface MenuItemOnClickProps {
	galleryInfos: GalleryInfosState;
	driveList: DriveListState;
	iconFileName: string;
	title: string;
	routing: RouterState;
	menuItem?: MenuItem;
	isBold?: boolean;
	badge?: number;
	onClick: () => void;
	dispatch: Dispatch<StoreState>;
}

enum LocationPathName {
	Folder = '/list/folder',
	Page = '/page',
}

class MenuItemOnClick extends React.Component<MenuItemOnClickProps, {}> {

	constructor(props: MenuItemOnClickProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.getImgElement = this.getImgElement.bind(this);
	}

	handleClick() {
		const { onClick, dispatch } = this.props;
		onClick();
		dispatch({ type: MenuActionKeys.REQUEST_CLOSE_LEFT_MENU });
	}

	getImgElement() {
		const { iconFileName, galleryInfos, driveList } = this.props;
		const { driveItems, resolutions } = driveList;
		const iconId = Utils.getMediaId(iconFileName);

		if (iconId > -1 && driveItems[iconId]) {
			const src = Utils.getCustomIconUrl(galleryInfos.config, driveItems[iconId], resolutions);
			return <img src={src} />;
		} else if (iconFileName.includes('iconset')) {
			return Utils.getSvgIcon(iconFileName);
		} else {
			return '';
		}
	}

	isActive() {
		const { routing, menuItem } = this.props;

		if (menuItem) {
			const { type, target } = menuItem;
			const targetId = Utils.getMediaId(target);
			let isActive = false;

			if (type === MenuItemType.Folder) {
				isActive = routing.locationBeforeTransitions.pathname === `${LocationPathName.Folder}/${targetId}`;
			} else if (type === MenuItemType.Page) {
				isActive = routing.locationBeforeTransitions.pathname === `${LocationPathName.Page}/${targetId}`;
			}
			return isActive;
		}
		return false;
	}

	render() {
		const { title, isBold, badge } = this.props;
		const imgElement = this.getImgElement();

		return (
			<StyledMenuItem
				onClick={this.handleClick}
				isBold={isBold}
				isActive={this.isActive()}
			>
				{imgElement}
				{title}
				{!!badge && <MenuItemBadge>{badge}</MenuItemBadge>}
			</StyledMenuItem>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, driveList, routing } = state;
	return { galleryInfos, driveList, routing };
};

export default connect(mapStateToProps)(MenuItemOnClick);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/MenuItem/OnClick/index.tsx